import {colors} from "@c10h/colors";
import Image from "next/image";
import React from "react";

import Circle from "./Circle";

const IMAGE_DIAMETER = 96;

const Title = ({children}: {children: React.ReactNode}) => (
  <span className="fs24 lh11 font-ttm font-semibold">{children}</span>
);
const Description = ({children}: {children: React.ReactNode}) => (
  <span className="font-ttm text-gray600 text-sm empty:hidden">{children}</span>
);
const Emphasis = ({children}: {children: React.ReactNode}) => (
  <em className="font-ttm text-darkGreen text-sm empty:hidden whitespace-nowrap not-italic">
    {children}
  </em>
);

const ImageRow = ({
  title,
  description,
  emphasis,
  src,
  alt,
}: {
  title: string;
  description: string;
  emphasis: string;
  src: string;
  alt?: string;
}): React.ReactElement => (
  <div className="flex items-center">
    <div
      className="rounded-full overflow-hidden flex-shrink-0"
      style={{
        height: IMAGE_DIAMETER,
        width: IMAGE_DIAMETER,
      }}
    >
      <Image
        src={src}
        alt={alt || ""}
        height={IMAGE_DIAMETER}
        width={IMAGE_DIAMETER}
        className="object-cover"
      />
    </div>
    <div className="block ml-4">
      <Title>{title}</Title>
      <div className="flex items-center flex-wrap mt-1 mb-2">
        <Description>{description}</Description>
        <div className="flex items-center">
          {emphasis && (
            <Circle
              color={colors.darkGreen}
              diameter={4}
              className="mx-2 hidden sm:block"
              aria-hidden
            />
          )}
          <Emphasis>{emphasis}</Emphasis>
        </div>
      </div>
    </div>
  </div>
);

export default React.memo(ImageRow);
